<!--婴幼儿管理-->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <!-- <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
      </div>
    </div> -->
    <el-card class="operate-container" shadow="never" style="margin-top: 0px">
      <div class="filter-container">
        <el-form :inline="true" :model="queryParam" label-width="113px">
          <el-form-item label="家长手机号:">
            <el-input v-model="queryParam.inputPhone" placeholder="请输入手机号" style="width: 147px"></el-input>
          </el-form-item>
          <!-- <el-form-item label="已使用课时:">
            <el-input-number
              v-model="queryParam.usedClass"
              placeholder="体验卡已使用课时"
            ></el-input-number>
          </el-form-item> -->
          <el-form-item label="会员姓名:">
            <el-input v-model="queryParam.inputUserChild" placeholder="请输入姓名" style="width: 147px"></el-input>
          </el-form-item>
          <el-form-item label="小名:">
            <el-input v-model="queryParam.inputChildNickName" placeholder="请输入小名" style="width: 147px"></el-input>
          </el-form-item>
          <el-form-item label="已使用课时:">
            <el-input-number
              :min="1"
              v-model="queryParam.usedClass"
              placeholder="已使用课时"
            ></el-input-number>
          </el-form-item
          <el-form-item style="margin-left: 30px">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
              询</el-button>
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
              @click="handleResetSearch()" style="margin-left: 30px">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="app-container-content">
      <div class="title-container" shadow="never" style="padding-top: 20px">
        <!-- <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px">数据列表 </span>
      </div> -->
        <div></div>
        <div class="d-flex a-center">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="handleCreateOne()">新 增</el-button>
          <!-- <el-button
          type="primary"
          size="medium"
          class="operator-btn"
          icon="el-icon-edit"
          @click="onChangeSuccessShowDlg()"
          >修改等级</el-button
        > -->
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit"
            @click="onUpdateChildInfoShow()">修改信息</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-shopping-bag-1"
            @click="onBuyExpCardShow()">购买体验卡</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-shopping-bag-1"
            @click="handClickOpenVipShow()">购买VIP卡</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-time" @click="handleBookLesson()">预
            约</el-button>
            <div class="spec-buton-box">
              <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-shopping-bag-1"
            @click="handClickOpenArrangeShow()">跟进安排</el-button>
              <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
            </div>
            <div class="spec-buton-box">
              <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-refresh"
            @click="onChnageExpCardShow()" style="margin-right: 23px">体验卡切换</el-button>
              <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
            </div>
          
          
          <!-- <el-button
          type="warning"
          size="medium"
          class="operator-btn2"
          icon="el-icon-reading"
          @click="handleByLesson()"
          >购 课</el-button
        > -->
        </div>
      </div>
      <div class="table-container" style="margin-top: 20px">
        <el-table ref="tableData" style="width: 100%" :data="tableData" max-height="520" v-loading="tableloading" border
          :highlight-current-row="false" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }" @row-click="rowClick" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="手机号" prop="phoneNumber" width="120">
          </el-table-column>
          <el-table-column label="会员姓名" prop="childName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="性别" prop="childGender"> </el-table-column>
          <el-table-column label="小名" prop="childPetName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="类型" prop="childType"> </el-table-column>
          <el-table-column label="月龄" prop="childMonth"> </el-table-column>
          <el-table-column label="生日" prop="childBirthday" width="120px">
          </el-table-column>
          <el-table-column label="创建日期" prop="inputTime" width="120px">
          </el-table-column>
          <el-table-column label="体验卡名称" prop="cardName" width="120px">
          </el-table-column>
          <el-table-column label="体验卡总课时" prop="totalLesssonCount" width="115px">
          </el-table-column>
          <el-table-column label="已用课时" prop="usedClass"> </el-table-column>
          <el-table-column label="剩余课时" prop="">
            <template slot-scope="{ row }">
              <span v-if="(row.totalLesssonCount && row.usedClass) ||
                row.totalLesssonCount == 0 ||
                row.usedClass == 0
                ">{{ row.totalLesssonCount - row.usedClass }}</span>
            </template>
          </el-table-column>
          <el-table-column label="渠道" prop="source" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="居住地址(小区)" prop="areaAddress" show-overflow-tooltip width="180px">
          </el-table-column>
          <el-table-column label="备注" prop="" width="219px">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                ">
                <p>{{ scope.row.remark }}</p>
                <!-- <p>{{ scope.row.recording }}</p> -->
                <img @click="clickAudio(scope.row)" style="width: 25px; height: 25px; margin-left: 5px;cursor: pointer;"
                  src="@/assets/icons/laba.png" alt="" v-if="scope.row.recording" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper" :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize" :page-sizes="queryParam.pageSizes" :total="queryParam.totalPage">
      </el-pagination>
    </div>

    <!--  预约课程-->
    <template v-if="visibleDlgBook">
      <el-dialog title="预约课程" :visible.sync="visibleDlgBook" width="1000px" center>
        <BookLessonForChildVTwo @onBookSuccess="onBookSuccess" :is-vip="false" :key="addRefresh" :child="selectRow"
          :store-lesson-exp-cards="storeLessonEXPCards" @onBtnCancel="visibleDlgBook = false" />
      </el-dialog>
    </template>

    <!-- 新增客户-->
    <template v-if="visibleDlgAdd">
      <el-dialog title="新增客户" :visible.sync="visibleDlgAdd" width="850px" center>
        <user-child-detail :key="addRefresh" :store-lesson-exp-cards="storeLessonEXPCards" @onBtnCreate="onBtnCreate"
          @onBtnCancel="onBtnCancel">
        </user-child-detail>
      </el-dialog>
    </template>

    <!--    修改会员等级-->
    <el-dialog title="修改会员等级" :visible.sync="visibleDlgUpdateChildLevel" width="50%" center>
      <change-child-level :child-id="changeChildLevelId" @onChangeSuccess="onChangeChildLevelCancel"
        :key="refreshchangeChildLevel"></change-child-level>
    </el-dialog>
    <!-- 购买体验卡-->
    <el-dialog title="购买体验卡" :visible.sync="visibleDlgBuyExpCard" width="1000px" center>
      <user-buy-exp-card @handleBuy="handleBuy" @onBtnCancel="visibleDlgBuyExpCard = false" :child-info="buyExpCardChild"
        :key="refreshBuyExpCard" :store-lesson-exp-cards="storeLessonEXPCards"></user-buy-exp-card>
    </el-dialog>
    <!-- 切换体验卡-->
    <el-dialog title="切换体验卡" :visible.sync="visibleDlgChangeExpCard" width="1000px" center>
      <user-change-exp-card @handleChange="handleChange" :child-id="updateChildId" :child-info="changeExpCardChild"
        :key="refreshChangeExpCard" :store-lesson-exp-cards="storeLessonEXPCards"
        @onBtnCancel="visibleDlgChangeExpCard = false"></user-change-exp-card>
    </el-dialog>
    <!-- 修改孩子信息-->
    <!-- <template v-if="visibleDlgUpdateChildInfo"> -->
    <el-dialog title="修改客户信息" :visible.sync="visibleDlgUpdateChildInfo" width="1000px" center>
      <update-child-info :key="updateRefresh" :child-id="updateChildId" @onBtnCancel="onBtnCancelUpdate"
        @handleUpdate="handleUpdateChild"></update-child-info>
    </el-dialog>
    <!-- </template> -->
    <buy-lesson-card-detail :key="refreshCard" :show="showAddCardDlg" :store-lesson-cards="storeLessonVIPCards"
      @onBtnOK="onBtnOKBuyCard()">
    </buy-lesson-card-detail>
    <!--  添加线索-->
    <el-dialog title="添加线索" :visible.sync="visibleDlgAddClue" width="50%" top="12vh" center>
      <create-cule :info="clueInfo" :all-worker="allWorker" @onCreateSuccess="onCreateClueSuccess"></create-cule>
    </el-dialog>
    <template v-if="visibleVipUpdateType">
      <el-dialog title="购买VIP卡" :visible.sync="visibleVipUpdateType" width="850px" center>
        <UpdateVipTypeInfo ref="UpdateVipTypeInfo" :child-id="updateChildId" @onBtnCancel="visibleVipUpdateType = false"
          @handleUpdate="handleUpdatevisibleVipUpdateType" :store-lesson-exp-cards="storeLessonEXPCards" />
      </el-dialog>
    </template>
    <template v-if="visibleArrangeUpdate">
      <el-dialog title="跟进安排" :visible.sync="visibleArrangeUpdate" width="800px" center>
        <arrange-update-info :child-info="followArrangeChild" @onBtnCancel="visibleArrangeUpdate = false"
          @onBtnhandleUpdate="onBtnhandleUpdate" />
      </el-dialog>
    </template>
    <template v-if="audioDialog">
      <el-dialog title="音频文件" width="500px" :visible.sync="audioDialog" center>
        <audioDialog ref="audioDialogRef" />
      </el-dialog>
    </template>
    <!-- <el-dialog
      title="客户跟进"
      :visible.sync="visibleClientFollow"
      width="1000px"
      center
    >
      <clientFollowInfo
        ref="clientFollowRef"
        :userId="this.followArrangeChild.userId"
      ></clientFollowInfo>
    </el-dialog> -->
  </div>
</template>

<style scoped lang="scss">
/deep/ .el-table th.el-table__cell>.cell {
  // width: 90%;
  height: 100%;
  background: #ecf3fd;
  // border-radius: 8px;
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

.app-container {
  .operate-container {
    border: none;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-card__body {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  &-content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
  }

  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 10px;
  }


  /deep/ .el-dialog {
    margin-top: 10vh !important;
  }

  .table-container {
    border: none;
    border-radius: 0px;

    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 0px;
        }
      }
    }
  }
}
</style>

<script>
import UserChildDetail from "./components/UserChildDetail";
import BuyLessonCardDetail from "../user-by-lesson-card/components/BuyLessonCardDetail";
import { qlUserChild } from "../../api/userChild";
import commonUtils from "../../utils/commonUtils";
import globaldata from "../../utils/globaldata";
import WorkerWord from "../../components/WorkerWord/WorkerWord";
import enumsUtil, { EChildGender } from "../../utils/enumsUtil";
import messageUtils from "../../utils/messageUtils";
import BookLessonForChildVTwo from "../components/BookLessonForChildVTwo";
import { selectCards } from "../../api/storeFront";
import UpdateChildInfo from "./components/UpdateChildInfo";
import CreateCule from "../marketing-manager/components/CreateCule";
import UserBuyExpCard from "./components/UserBuyExpCard";
import UserChangeExpCard from "./components/UserChangeExpCard";
import ChangeChildLevel from "../components/ChangeChildLevel";
import UpdateVipTypeInfo from "./components/UpdateVipTypeInfo.vue";
import arrangeUpdateInfo from "./components/arrangeUpdateInfo";
import audioDialog from "@/components/audioDialog";

import clientFollowInfo from "./components/ClientFollow.vue";

export default {
  components: {
    UserChangeExpCard,
    ChangeChildLevel,
    UserBuyExpCard,
    CreateCule,
    UpdateChildInfo,
    BookLessonForChildVTwo,
    WorkerWord,
    UserChildDetail,
    BuyLessonCardDetail,
    UpdateVipTypeInfo,
    arrangeUpdateInfo,
    audioDialog,
    clientFollowInfo,
  },
  data() {
    return {
      //弹窗
      audioDialog: false,
      visibleArrangeUpdate: false,
      visibleVipUpdateType: false,
      visibleDlgAdd: false,
      visibleDlgBook: false,
      visibleDlgInfo: false,
      visibleDlgDelete: false,
      visibleDlgWord: false,
      visibleDlgUpdateChildInfo: false,
      visibleDlgAddClue: false,
      visibleDlgBuyExpCard: false,
      visibleDlgChangeExpCard: false,
      visibleDlgUpdateChildLevel: false,
      visibleClientFollow: false,
      addRefresh: "",
      updateRefresh: "",
      refreshWord: "",
      queryParam: {
        inputPhone: "", //输入手机号
        inputUserName: "", //输入会员名
        inputUserChild: "", //输入会员孩子名
        inputChildNickName: "", //孩子小米
        usedClass:undefined,
        inputUserArea: "", //所属社区
        birthday: "", //生日
        sliderMonthValue: [0, 100],
        sliderMonthMarks: {
          0: "0",
          50: "50",
          100: "100",
        },
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 30],
      },

      storeLessonVIPCards: [], //VIP卡
      storeLessonEXPCards: [], //体验卡
      showAddCardDlg: false,
      refreshCard: "",

      buyParam: {},

      createParam: {},

      //表单结果
      tableData: [],
      tableloading: true,
      selectRow: null,
      updateChildId: 0,
      changeChildLevelId: 0,
      followChildId: null,
      refreshchangeChildLevel: "",
      clueInfo: "",
      allWorker: "",
      multipleSelection: [],

      refreshBuyExpCard: "",
      buyExpCardChild: "",
      changeExpCardChild: "",
      followArrangeChild: "",
      refreshChangeExpCard: "",
      isVip: globaldata.getAdminStore().isVip,
    };
  },
  created() {
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    this.getStoreLessonCard();
  },
  activated() { },
  mounted() { },
  methods: {
    clickAudio(val) {
      this.audioDialog = true
      console.log(val, this.$refs.audioDialogRef, 'refs.audioDialogRef=======')
      this.$nextTick(() => {
        this.$refs.audioDialogRef.audio = val.recording
      })
    },
    getStoreLessonCard() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        statu: 0,
        exp: null,
      };
      selectCards(param).then((response) => {
        let data = response.data;
        this.storeLessonVIPCards = [];
        this.storeLessonEXPCards = [];
        for (let i = 0; i < data.length; ++i) {
          if (data[i].experience == 1) {
            this.storeLessonEXPCards.push(data[i]);
          } else {
            this.storeLessonVIPCards.push(data[i]);
          }
        }
        this.flechList();
      });
    },
    getStoreWorkersInfo(workers) {
      this.allWorker = workers;
    },
    flechList() {
      this.tableloading = true;
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        name: this.queryParam.inputUserChild,
        petName: this.queryParam.inputChildNickName,
        usedClass: this.queryParam.usedClass,
        userName: this.queryParam.inputUserName,
        userPhone: this.queryParam.inputPhone,
        pageNum: this.queryParam.pageNum, //当前第几页
        pageSize: this.queryParam.pageSize,
      };
      qlUserChild(param).then((response) => {
        this.tableloading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.queryParam.totalPage = date.total;
        this.refreshData(date.list);
      });
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      let tableDataList = [];
      for (let i = 0; i < list.length; ++i) {
        let genderDes = EChildGender(list[i].gender);
        let childType = enumsUtil.childBodyType(list[i].childType);
        let data = {
          ...list[i],
          number: i + 1,
          id: list[i].id,
          userId: list[i].userId,
          userName: list[i].userName,
          phoneNumber: list[i].userPhone,
          childName: list[i].name,
          gender: list[i].gender,
          childGender: genderDes,
          childPetName: list[i].petName,
          childBirthday: list[i].birthday,
          areaAddress: list[i].areaAddress,
          childMonth: list[i].childMonth,
          source: list[i].source,
          usedClass: list[i].usedClass,
          totalLesssonCount: list[i].totalLesssonCount,
          cardName: list[i].cardName,
          totalPay: list[i].totalPay,
          childType: childType,
        };
        tableDataList.push(data);
      }
      this.tableData = tableDataList;
    },

    rowClick(row, column, event) {
      console.log(row, "=====rowClik");
      this.selectRow = row;
    },
    handleCheckSelect() {
      let self = this
      if (self.multipleSelection.length == 0 || self.multipleSelection.length > 1) {
        messageUtils.errorMsg(self, "请先选择一条信息");
        return false
      }
      self.selectRow = self.multipleSelection[0]
      return true;
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      // return true;
    },
    onChangeSuccessShowDlg() {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      this.changeChildLevelId = this.selectRow.id;
      this.refreshchangeChildLevel = new Date().getTime();
      this.visibleDlgUpdateChildLevel = true;
    },
    onChangeChildLevelCancel() {
      this.visibleDlgUpdateChildLevel = false;
    },
    onBtnCreate() {
      this.visibleDlgAdd = false;
      this.flechList();
    },
    onBtnCancel() {
      this.visibleDlgAdd = false;
    },
    onBtnOKBuyCard() {
      this.showAddCardDlg = false;
      this.refreshCard = new Date().getTime();
    },
    handleUpdateChild() {
      this.visibleDlgUpdateChildInfo = false;
      this.selectRow = null;
      this.flechList();
    },
    onBtnhandleUpdate() {
      this.visibleArrangeUpdate = false;
      this.selectRow = null;
      this.flechList();
    },
    onBtnCancelUpdate() {
      this.visibleDlgUpdateChildInfo = false;
    },
    handleUpdatevisibleVipUpdateType() {
      this.visibleVipUpdateType = false;
      this.selectRow = null;
      this.flechList();
    },

    //点击查询按钮
    onBtnSearch() {
      this.flechList();
    },
    // 重置
    handleResetSearch() {
      this.queryParam = {
        inputPhone: "", //输入手机号
        inputUserName: "", //输入会员名
        inputUserChild: "", //输入会员孩子名
        inputChildNickName: "", //孩子小米
        usedClass:undefined,
        inputUserArea: "", //所属社区
        birthday: "", //生日
        sliderMonthValue: [0, 100],
        sliderMonthMarks: {
          0: "0",
          50: "50",
          100: "100",
        },
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 30],
      }
      this.flechList();
    },
    handleBookLesson() {
      if (!this.handleCheckSelect()) {
        return;
      }
      this.addRefresh = new Date().getTime();
      this.visibleDlgBook = true;
    },

    handleCreateOne() {
      this.addRefresh = new Date().getTime();
      this.visibleDlgAdd = true;
    },
    handleByLesson() {
      this.showAddCardDlg = true;
      this.refreshCard = new Date().getTime();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.flechList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.flechList();
    },
    onBookSuccess() {
      this.visibleDlgBook = false;
    },

    onUpdateChildInfoShow() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      let self = this
      if (!self.handleCheckSelect()) {
        return;
      }
      console.log("this.selectRow", this.selectRow);
      this.updateChildId = this.selectRow.id;
      this.visibleDlgUpdateChildInfo = true;
      this.updateRefresh = new Date().getTime();
    },

    /**
     * 添加线索
     */
    handleAddClueDig() {
      if (!this.handleCheckSelect()) {
        return;
      }

      this.clueInfo = {
        childId: this.selectRow.id,
        userId: this.selectRow.userId,
        childName: this.selectRow.childName,
        childPetName: this.selectRow.childPetName,
        userPhone: this.selectRow.phoneNumber,
      };
      this.visibleDlgAddClue = true;
    },

    onCreateClueSuccess() {
      this.visibleDlgAddClue = false;
    },

    handleBuy() {
      this.visibleDlgBuyExpCard = false;
      this.flechList();
    },

    onBuyExpCardShow() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      let self = this
      if (!self.handleCheckSelect()) {
        return;
      }
      // this.buyExpCardChild = {
      //   name: this.selectRow.childName,
      //   userPhone: this.selectRow.phoneNumber,
      //   userId: this.selectRow.userId,
      // };
      this.buyExpCardChild = this.selectRow;
      console.log("buyExpCardChild", this.buyExpCardChild);

      this.visibleDlgBuyExpCard = true;
      this.refreshBuyExpCard = new Date().getTime();
    },

    handClickOpenVipShow() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      let self = this
      if (!self.handleCheckSelect()) {
        return;
      }
      this.updateChildId = this.selectRow.id;

      this.visibleVipUpdateType = true;
      this.$nextTick(() => {
        this.$refs.UpdateVipTypeInfo.initParam()
      })
    },

    handClickOpenArrangeShow() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      let self = this
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if (!self.handleCheckSelect()) {
        return;
      }
      this.followArrangeChild = {
        userPhone: this.selectRow.phoneNumber,
        name: this.selectRow.childName,
        birthday: this.selectRow.birthday,
        userId: this.selectRow.userId,
        gender: this.selectRow.childGender,
        petName: this.selectRow.childPetName,
        masterId: this.selectRow.masterId
      };
      this.visibleArrangeUpdate = true;
      // this.followChildId = this.selectRow.userId
    },

    onChnageExpCardShow() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      let self = this
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if (!self.handleCheckSelect()) {
        return;
      }
      this.updateChildId = this.selectRow.id;
      // let ojfd = [{
      //     lessonsId: '',
      //     level: '',
      //   }]
      this.changeExpCardChild = {
        name: this.selectRow.childName,
        userPhone: this.selectRow.phoneNumber,
        userId: this.selectRow.userId,
        gender: this.selectRow.childGender,
        petName: this.selectRow.childPetName,
        level: this.selectRow.level,
        remark: this.selectRow.remark,
        recording: this.selectRow.recording,
        expCardPay: this.selectRow.totalPay,
        userChildId: this.selectRow.id,
        // userBuyLevels: ojfd,
        residueCount:
          this.selectRow.totalLesssonCount - this.selectRow.usedClass,
      };

      this.visibleDlgChangeExpCard = true;
      this.refreshChangeExpCard = new Date().getTime();
    },

    handleChange() {
      this.visibleDlgChangeExpCard = false;
      this.flechList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user_child/index.vue